import React from 'react';
// Moment library size is very high 100kb zipped and minified

// import { format } from 'date-fns';
// import PropTypes from 'prop-types';
import Link from 'components/Link';
import CookieObj from '../../../common/EducationWidget/helper';
import s from '../TopBar/TopBar.scss';

class SnackPopup extends React.Component {
  constructor() {
    super();
    this.state = {
      showSnackPopup: false,
    };
  }

  componentDidMount() {
    this.checkAndShowSnackPopup();
  }

  closeSnackPopup = e => {
    e.preventDefault();
    this.setState({ showSnackPopup: false });
    CookieObj.set_cookie('snack_frequency', 1, 365, '/', '.indiatimes.com', '');
  };

  showSnackPopup() {
    this.setState({ showSnackPopup: true });
  }

  checkAndShowSnackPopup = () => {
    const snackFrequency = CookieObj.get_cookie('snack_frequency');
    let saveddate = CookieObj.get_cookie('snack_lastfiredtimestamp');
    const snackNumberofDaystoAdd = CookieObj.get_cookie(
      'snack_numberofdaystoadd',
    );
    let freq = 0;
    let numberOfDaysToAdd = 0;
    if (
      snackFrequency === 'undefined' ||
      (snackFrequency !== 'undefined' && snackFrequency < 2)
    ) {
      if (saveddate !== 'undefined') {
        saveddate = new Date(saveddate.replace(/%20/g, ' '));
      } else {
        saveddate = new Date();
      }

      freq = snackFrequency === 'undefine' ? 0 : snackFrequency;
      numberOfDaysToAdd =
        snackNumberofDaystoAdd === 'undefined' ? 0 : snackNumberofDaystoAdd;
      const nextDate = this.addDays(saveddate, parseInt(numberOfDaysToAdd, 10));

      if (
        (nextDate.getTime() < new Date().getTime() &&
          parseInt(freq, 10) <= 2) ||
        parseInt(freq, 10) === 0
      ) {
        this.showSnackPopup();
        if (freq === 0) numberOfDaysToAdd = 3;
        else if (freq === 1) numberOfDaysToAdd = 5;
        else numberOfDaysToAdd = 365;
        freq += 1;
        this.setSnackPopupCookie(freq, numberOfDaysToAdd, new Date());
      }
    }
  };

  addDays = (theDate, days = 1) =>
    new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);

  setSnackPopupCookie = (frequen, nOfDays, dateVal = new Date()) => {
    CookieObj.set_cookie(
      'snack_lastfiredtimestamp',
      dateVal.toDateString(),
      365,
      '/',
      '.indiatimes.com',
      '',
    );
    CookieObj.set_cookie(
      'snack_numberofdaystoadd',
      nOfDays,
      365,
      '/',
      '.indiatimes.com',
      '',
    );
    CookieObj.set_cookie(
      'snack_frequency',
      frequen,
      365,
      '/',
      '.indiatimes.com',
      '',
    );
  };

  render() {
    const { showSnackPopup } = this.state;
    if (showSnackPopup) {
      return (
        <div className={s.locationdetect}>
          {/* please use this "locationdetectshow" to show and hide */}
          <p>
            You can change your city from here.<br />
            We serve <span>personalized stories</span> based on the selected
            city
          </p>
          <Link
            className={s.okbtn}
            href="/"
            onClick={e => this.closeSnackPopup(e)}
          >
            OK
          </Link>
        </div>
      );
    }
    return null;
  }
}

SnackPopup.propTypes = {};
SnackPopup.defaultProps = {};

export default SnackPopup;
